import {
	DropdownFormInput,
	FieldValidationError,
	FormGroup,
	useLanguageResource,
} from "@ruter-as/web-components-and-tools";
import type React from "react";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useAuthContext } from "../../auth/Auth.component";
import "./ZoneSelector.scss";
import zoneLanguageResource from "./lang-resources";

interface Props {
	disabled?: boolean;
}

const ZONE_FROM_NAME = "zoneFrom";
export const ZONE_TO_NAME = "zoneTo";

const ZoneSelector: React.FC<Props> = ({ disabled = false }) => {
	const lang = useLanguageResource(zoneLanguageResource);
	const { zones } = useAuthContext();
	const { formState, clearErrors, watch } = useFormContext();

	const { zoneFrom, zoneTo } = watch();
	const noChangeError =
		formState.errors.zoneFrom?.type === "no-change" &&
		formState.errors.zoneFrom.message;

	// biome-ignore lint/correctness/useExhaustiveDependencies: clears zone errors whenever the selected zones change
	useEffect(() => {
		clearErrors(["zoneFrom", "zoneTo"]);
	}, [zoneFrom, zoneTo, clearErrors]);

	return (
		<>
			<FormGroup className="zone-selector-component">
				<div className="zone">
					<DropdownFormInput
						disabled={disabled}
						label={lang.from}
						name={ZONE_FROM_NAME}
					>
						{zones.map((zone) => (
							<option key={zone.name} value={zone.name}>
								{zone.name}
							</option>
						))}
					</DropdownFormInput>
				</div>
				<div className="zone">
					<DropdownFormInput
						disabled={disabled}
						label={lang.to}
						name={ZONE_TO_NAME}
					>
						{zones.map((zone) => (
							<option key={zone.name} value={zone.name}>
								{zone.name}
							</option>
						))}
					</DropdownFormInput>
				</div>
			</FormGroup>
			{noChangeError && (
				<div data-test-id="no-change-error-validation-message">
					<FieldValidationError text={noChangeError.toString()} />
				</div>
			)}
		</>
	);
};

export default ZoneSelector;
